// ═══════════════════════════════════════════════════════════════════════════════
// Receipt amount helpers — total vs line-item sum
// ═══════════════════════════════════════════════════════════════════════════════
export const parseReceiptItemAmount = (amount) => {
    if (amount === '') {
        return null;
    }
    const n = typeof amount === 'number' ? amount : Number(amount);
    if (!Number.isFinite(n)) {
        return null;
    }
    return n;
};
export const parseReceiptTotalAmount = (totalAmount) => {
    if (totalAmount === '') {
        return null;
    }
    const n = typeof totalAmount === 'number' ? totalAmount : Number(totalAmount);
    if (!Number.isFinite(n)) {
        return null;
    }
    return n;
};
/** Sum named line items; blank or invalid amount counts as 0. */
export const sumReceiptLineItemAmounts = (items) => items.reduce((sum, row) => {
    const name = row.item.trim();
    if (name === '') {
        return sum;
    }
    const amount = parseReceiptItemAmount(row.amount);
    return sum + (amount ?? 0);
}, 0);
export const isReceiptTotalMismatch = (totalAmount, items) => {
    const total = parseReceiptTotalAmount(totalAmount);
    if (total === null) {
        return false;
    }
    const lineSum = sumReceiptLineItemAmounts(items);
    return Math.round(total * 100) !== Math.round(lineSum * 100);
};
export const formatReceiptMoney = (amount) => `$${amount.toFixed(2)}`;
//# sourceMappingURL=receiptAmount.js.map